export const processContentfulConfig = (contentfulConfig) => {
    if (!contentfulConfig) {
        return null;
    }

    try {
        const config = typeof contentfulConfig === 'string' 
            ? JSON.parse(contentfulConfig) 
            : contentfulConfig;
        
        return config;
    } catch (error) {
        console.warn('Invalid Contentful config format:', error);
        return null;
    }
};

export const validateConfig = (config) => {
    if (!config || typeof config !== 'object') {
        return false;
    }
    
    if (!config.user || !config.GTM) {
        return false;
    }
    
    return true;
};
